/**
 * Route for `capi-event-quality-score-monitoring`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CapiEventQualityScoreMonitoringPage } from "../features/capi-event-quality-score-monitoring/CapiEventQualityScoreMonitoringPage";

export const capiEventQualityScoreMonitoringRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/capi-event-quality-score-monitoring",
	component: CapiEventQualityScoreMonitoringPage,
});

export default capiEventQualityScoreMonitoringRoute;
